import { TASK_STATUS_NAMES } from '../../../constants';

export const getTaskNameByStatus = (status) => {
    return TASK_STATUS_NAMES[status] || status;
};
